<div class="outer p-4 p-md-5">
  <div class="crossdiv"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
  <div class="header">Please Type CVV</div>
  <div class="global-yellow-bar"></div>
  <div class="inputsection">
    <input type="text" placeholder="CVV Number" class="inputtxt" [(ngModel)]="cvv"/>
    <div (click)="showTooltip()"><img class="helptext"src="../../../../../assets/icons/tooltip.png" ></div>
    <div id="cashtooltip" class="tooltip" *ngIf="tooltipVisibleForCashInfo" >
      <button class="tooltip-close" (click)="hideTooltip()">×</button>
      <span class="tipheader">What is CVV?</span>
      <p class="tipbody">The CVV (Card Verification Value) is a security code on credit and debit cards: 3 digits on the back of Visa, Mastercard, and Discover, or 4 digits on the front of American Express.</p>
    </div>
  </div>
  <div class="global-button-format">
    <button (click)="addCVV()" class="dw-primary-button icon-right">Next<mat-icon class="black">keyboard_arrow_right</mat-icon></button>
  </div>
</div>